import {Helmet} from "react-helmet";
import {
    Box,
    Button,
    Container,
    Fade,
    Grid,
    IconButton,
    InputAdornment, MenuItem,
    Paper, Select,
    Skeleton,
    Stack, styled, TextField,
    Typography
} from "@mui/material";
import {useEffect, useState} from "react";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {getMyShares} from "../../../lib/services/drive";
import Toasty from "../../../theme/components/Toasty";
import {farsiDate, farsiHour} from "../../../lib/commonFunctions/dateConvertor";
import {CancelOutlined, DoneRounded, SearchRounded} from "@mui/icons-material";
import {Pagination} from "../../../theme/components/Pagination";
import CustomInput from "../../../theme/components/CustomInput";
import CustomSelect from "../../../theme/components/CustomSelect";

const MyShares = () => {

    const [shares, setShares] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [page, setPage] = useState(searchParams.get('page') || '1');
    const [perPage, setPerPage] = useState(searchParams.get('size') || '12');
    const [pagesCount, setPagesCount] = useState(0);
    const [loading, setLoading] = useState(true);

    // filters
    const [sortMethod, setSortMethod] = useState(searchParams.get('sort') || 'descending');
    const [orderBy, setOrderBy] = useState(searchParams.get('orderBy') || 'date');

    const navigate = useNavigate();
    const [searchInput, setSearchInput] = useState('');
    const searchQuery = searchParams.get('search');

    const handleSearch = async (value) => {
        if (value === searchQuery || !value && !searchQuery) return;
        setPage(1);
        if (!value) navigate("/drive/my-shares");
        else navigate(`/drive/my-shares?search=${value}`);
        setLoading(true);
    }


    async function getData() {
        setLoading(true);
        try {
            const {data} = await getMyShares(page, perPage, {sortMethod, orderBy, filterClause: searchQuery});
            if (data?.isSuccess) {
                setShares(data.value?.data);
                setPagesCount(Math.ceil(data.value?.countData / perPage));
            } else {
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
        } catch (err) {
            console.log(err);
            Toasty.error('خطایی غیرمنتظره رخ داد');
        }
        setLoading(false);
    }

    // Get Data
    useEffect(() => {
        if (loading) {
            getData();
        }
    }, [page, loading]);
    // Change Page
    useEffect(() => {
        if (page) {
            navigate(`/drive/my-shares?page=${page}&size=${perPage}${searchQuery ? `&search=${searchQuery}` : ''}&sort=${sortMethod}&orderBy=${orderBy}`);
            window.scrollTo({top: 0, behavior: "smooth"})
            setLoading(true);
        }
    }, [page, searchQuery, sortMethod, orderBy]);
    // Get Search Data
    // useEffect(() => {
    //     if (searchQuery) {
    //         if (!allShares.length) return;
    //         handleFindSearchItems(searchQuery);
    //     } else {
    //         if (allShares.length || loading) return;
    //         getAllShares();
    //     }
    // }, [searchQuery, page, allShares]);

    return (
        <>
            <Helmet>
                <title>درایو میلفا - لیست فایل های ارسالی</title>
                </Helmet>
            <Container sx={{ mt: 3 }}>
                <Typography fontSize={{ xs: "1.1rem" }} fontWeight={600}>لیست فایل های ارسالی من</Typography>
                {/* Filters */}
                <Grid mt={1} container spacing={2}>
                    <Grid item xs={12} lg={6} xl={7}>
                        <Box
                            component="form"
                            onSubmit={(e) => {e.preventDefault(); handleSearch(searchInput)}}
                            position="relative">
                            <CustomInput
                                disabled={loading}
                                value={searchInput} onChange={(e) => setSearchInput(e.target.value)}
                                fullWidth
                                label="جستجو" placeholder="عبارت مورد نظر خود را وارد کنید"
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton disabled={loading} type="submit"><SearchRounded fontSize="small"/></IconButton>
                                    </InputAdornment>
                                }/>
                        </Box>
                    </Grid>
                    <Grid item xs={12} lg={6} xl={5} container spacing={1.5}>
                        <Grid item xs={12} lg={6}>
                            <CustomSelect
                                label="نوع مرتب سازی" disabled={loading}
                                value={sortMethod} onChange={(e) => setSortMethod(e.target.value)}>
                                <MenuItem value="ascending">از کم به زیاد</MenuItem>
                                <MenuItem value="descending">از زیاد به کم</MenuItem>
                            </CustomSelect>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <CustomSelect
                                label="مرتب سازی بر اساس" disabled={loading}
                                value={orderBy} onChange={(e) => setOrderBy(e.target.value)}>
                                <MenuItem value="date">تاریخ</MenuItem>
                                <MenuItem value="title">عنوان</MenuItem>
                                <MenuItem value="phoneNumber">شماره موبایل</MenuItem>
                                <MenuItem value="firstName">نام</MenuItem>
                                <MenuItem value="lastName">نام خانوادگی</MenuItem>
                            </CustomSelect>
                        </Grid>
                    </Grid>
                </Grid>
                {!loading
                    ?
                    <>
                        <Fade in={!!searchQuery} sx={{ mt: 1 }} unmountOnExit>
                            <Typography>عبارت جستجو: {searchQuery}</Typography>
                        </Fade>
                        {shares.length
                            ?
                            <>
                                <Grid mt={3} container spacing={2}>
                                    {shares.map((s, ind) => (
                                        <Grid key={ind} item xs={12} md={6} lg={4} xl={3}>
                                            <SharedItem data={s}/>
                                        </Grid>
                                    ))}
                                </Grid>
                                <Box my={5} display='flex' alignItems='center' justifyContent='center'>
                                    <Pagination
                                        page={parseInt(page)}
                                        onChange={(e, newPage) => setPage(newPage)}
                                        count={pagesCount}/>
                                </Box>
                            </>
                            :
                            <Typography mt={3.5}>هیج اشتراک گذاری ای یافت نشد</Typography>
                        }
                    </>
                    :
                    <LoadingSkeleton/>
                }
            </Container>
        </>
    )
}
export default MyShares;

const SharedItem = ({data}) => {

    const YesOrNo = ({boolean}) => {
        switch (boolean) {
            case true: return <DoneRounded color="success" fontSize="small"/>
            case false: return <CancelOutlined color="error" fontSize="small"/>;
            default: return <CancelOutlined color="error" fontSize="small"/>;
        }
    }

    return (
        <Paper sx={{ p: 2, height: 1, display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
            <Stack spacing={1.5}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography>کد اشتراک:</Typography>
                    <Typography>{data.linkAddress}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography>عنوان:</Typography>
                    <Typography>{data.title ? data.title : "نامشخص"}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography>تاریخ ایجاد:</Typography>
                    <Typography>{data.createDate ? farsiHour(data.createDate) + " - " + farsiDate(data.createDate) : "نامشخص"}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography>نام گیرنده:</Typography>
                    <Typography>{data.senderFirstName && data.senderLastName ? data.senderFirstName + " " + data.senderLastName : "نامشخص"}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography>شماره موبایل گیرنده:</Typography>
                    <Typography>{data.senderMobileNumber ? data.senderMobileNumber : "نامشخص"}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography>توضیحات:</Typography>
                    <Typography>{data.description ? data.description : "نامشخص"}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography>به اتمام رسیده:</Typography>
                    <YesOrNo boolean={data.isExpired}/>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography>دسترسی عمومی:</Typography>
                    <YesOrNo boolean={data.isPublic}/>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography>دارای رمز:</Typography>
                    <YesOrNo boolean={data.isPassword}/>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography>نیاز به ورود:</Typography>
                    <YesOrNo boolean={data.isNeedRegister}/>
                </Stack>
            </Stack>
            <Link to={`/share/${data.linkAddress}`}>
                <Button variant="contained" fullWidth disableElevation sx={{ mt: 1.5  }}>مشاهده</Button>
            </Link>
        </Paper>
    )
}
const LoadingSkeleton = () => {
    return (
        <Grid mt={3} container spacing={2}>
            {Array.from([...Array(12)]).map((_, ind) => (
                <Grid key={ind} item xs={12} md={6} lg={4} xl={3}>
                    <Skeleton key={ind} variant="rounded" sx={{ height: "20rem" }}/>

                </Grid>
            ))}
        </Grid>
    )
}
